import { memo } from 'react';
import StageCard from "./StageCard";
import enhancer from "./enhancer";
export default /*#__PURE__*/memo(enhancer(StageCard));